import React, {useEffect, useState} from 'react';
import NavBar from "../../Component/NavBar/NavBar";
import {MdOutlineBlock, MdOutlineVerifiedUser} from "react-icons/md";
import {IoIosAddCircleOutline} from "react-icons/io";
import apiRequests from "../../Component/axios/config/config";
import Loading from "../../Component/Loading/Loading";
import toast from "react-hot-toast";
import {useNavigate} from "react-router-dom";
import Dropdown from "../../Component/Dropdown/Drowdown";
import {BiSolidUserDetail} from "react-icons/bi";
import {FaPlus} from "react-icons/fa";


export default function Users() {

    const navigate = useNavigate();
    const [searchQuery, setSearchQuery] = useState("");
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [checkStatus, setCheckStatus] = useState("All User");

    const [UserBlock, setUserBlock] = useState("");

    // const [showModalEdit, setShowModalEdit] = useState(false);
    const [showAddModal, setShowAddModal] = useState(false);

    const [showModalDelete, setShowModalDelete] = useState(false);
    const [name, setName] = useState(false)
    const [UserId, setUserId] = useState("");
    const [statusUsers, setStatusUsers] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);


    function apiGetUser(page = currentPage) {
        setLoading(true);
        const params = {
            isDeleted: UserBlock,
            page: page,
            limit: 10,
        };

        if (searchQuery) {
            params.search = searchQuery;
        }
        apiRequests.get("/api/user/v1/get-usersList-by-admin", {params})
            .then((response) => {
                setUsers(response.data.data.docs);
                setTotalPages(response.data.data.totalPages);
            })
            .catch((error) => {
                if (error.status === 401 || error.status === 403) {
                    navigate("/login");
                }

            })
            .finally(() => setLoading(false));
    }

    useEffect(() => {
        apiGetUser(currentPage);
    }, [UserBlock, currentPage, searchQuery]);


    function EditUser(id) {
        navigate(`/user/${id}`);
    }


    function ChangeStatusUser(id, name, status) {
        setShowModalDelete(true)
        setStatusUsers(status)
        setName(name)
        setUserId(id)
    }

    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };


    return (

        <div className="p-6">

            <div className="text-3xl font-bold text-gray-800 mb-6">
                Users Management
            </div>

            <NavBar
                item={
                    [
                        {
                            icon: <BiSolidUserDetail style={{fontSize: "22px"}}/>,
                            title: "All User",
                            value: checkStatus,
                            onClick: () => {
                                setUserBlock("");
                                setCheckStatus("All User")
                            }
                        },
                        {
                            icon: <MdOutlineVerifiedUser/>, title: "Active User", value: checkStatus, onClick: () => {
                                setUserBlock(false);
                                setCheckStatus("Active User")
                            }
                        },
                        {
                            icon: <MdOutlineBlock/>, title: "Block User", value: checkStatus, onClick: () => {
                                setUserBlock(true);
                                setCheckStatus("Block User")
                            }
                        },
                        {icon: <IoIosAddCircleOutline/>, title: "Add User", onClick: () => setShowAddModal(true)},
                    ]
                }
                onSearch={(value) => {
                    setSearchQuery(value);
                    setCurrentPage(1);
                }}
            />


            <div className="flex justify-center mt-8">
                <div className="w-full max-w-6xl md:overflow-x-auto">
                    <table className="w-full bg-white shadow-md rounded-lg ">
                        <thead
                            className="bg-gradient-to-r text-left from-buttonColor-shade4 to-marginColor-shade9 text-white">
                        <tr>
                            <th className="px-4 py-2 text-md font-medium rounded-tl-lg">User Name</th>
                            <th className="px-4 py-2 text-md font-medium">Mobile Number</th>
                            <th className="px-4 py-2 text-md font-medium">Status</th>
                            <th className="px-4 py-2 text-md font-medium rounded-tr-lg">Action</th>
                        </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                        {loading ?
                            <tr>
                                <td className="px-4 py-3 text-center" colSpan="4">
                                    <Loading/>
                                </td>
                            </tr>
                            :
                            users.length > 0 ?
                                users.map((item) =>
                                    <tr key={item._id}>
                                        <td className="px-4 py-2 text-md font-medium rounded-tl-lg">{item.userName || "-"}</td>
                                        <td className="px-4 py-2 text-md font-medium">{item.mobile}</td>
                                        <td className={`px-4 py-4`}>
                                        <span className={`px-2 hover:cursor-pointer py-1 rounded-full text-xs font-medium 
                                            ${item.isDeleted ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'}`}
                                              onClick={() => ChangeStatusUser(item._id, item.userName, item.isDeleted)}

                                        >
                                            {item.isDeleted ? 'Deleted' : 'Active'}
                                        </span>
                                        </td>
                                        <td className="px-4 py-2 text-md font-medium rounded-tr-lg">
                                            <button
                                                className="text-blue-500 hover:text-blue-700 font-medium mr-4"
                                                onClick={() => EditUser(item._id)}
                                            >
                                                Edit
                                            </button>
                                            {/*<button*/}
                                            {/*    className="text-red-500 hover:text-red-700 font-medium"*/}
                                            {/*>*/}
                                            {/*    Delete*/}
                                            {/*</button>*/}
                                        </td>
                                    </tr>
                                )
                                :
                                <tr className="">
                                    <td className="px-4 py-3 text-center" colSpan="4">User not found!</td>
                                </tr>
                        }


                        </tbody>
                    </table>
                </div>
            </div>
            {/* Pagination */}
            <div className="flex justify-center items-center mt-6 space-x-2">
                <button
                    disabled={currentPage === 1}
                    onClick={() => handlePageChange(currentPage - 1)}
                    className={`px-3 py-1 rounded-md border ${
                        currentPage === 1
                            ? "text-gray-400 border-gray-200"
                            : "text-blue-600 border-blue-400 hover:bg-blue-100"
                    }`}
                >
                    Prev
                </button>

                <span className="px-4">
                    Page {currentPage} of {totalPages}
                </span>

                <button
                    disabled={currentPage === totalPages}
                    onClick={() => handlePageChange(currentPage + 1)}
                    className={`px-3 py-1 rounded-md border ${
                        currentPage === totalPages
                            ? "text-gray-400 border-gray-200"
                            : "text-blue-600 border-blue-400 hover:bg-blue-100"
                    }`}
                >
                    Next
                </button>
            </div>


            {showModalDelete &&
                <ModalChangeStatus setShow={setShowModalDelete} name={name} status={statusUsers} apiGetUser={apiGetUser}
                                   id={UserId}/>}


            {showAddModal &&
                <ModalAddUser setShow={setShowAddModal} apiGetUser={apiGetUser}/>

            }
        </div>
    )

}


export function ModalChangeStatus({setShow, id, name, apiGetUser, status}) {


    const [loading, setLoading] = useState(false);


    function ChangeStatus() {

        setLoading(true)
        apiRequests.delete(status ? `/api/user/v1/unblock-user-admin` : `/api/user/v1/block-user-admin`, {
            data: {
                userId: id
            }
        })
            .then((res) => {
                toast.success(res.data.en_message)
                setShow(false)
                apiGetUser()
            })
            .catch(() => {
            })
            .finally(() => setLoading(false));

    }

    return (

        <div className="report-modal fixed inset-0 bg-black bg-opacity-60 transition-opacity">
            <div className="flex min-h-full items-end justify-center p-3 text-center">
                <div
                    className="modal relative text-black transform overflow-hidden rounded-lg bg-white p-8 w-[30%] md:w-[95%] m-auto flex flex-col gap-5">

                    <div className="text-gray-500">
                        Do you want to change the status of
                        <span className="text-firstColor-shade9 font-bold"> {name} </span>
                        ?
                    </div>

                    <div className="flex justify-center items-center gap-5 ">

                        <button
                            className={`px-4 py-1 border-2  ${status ? `hover:bg-firstColor-shade4 hover:text-white border-firstColor-shade4 text-firstColor-shade4` : `hover:bg-red-600 hover:text-white border-red-600 text-red-600`}  rounded-lg `}
                            onClick={ChangeStatus}
                        >
                            {loading ?
                                <Loading textColor={status && `white-0`}/>
                                :
                                status ?
                                    "Unblock"
                                    :
                                    "block"
                            }
                        </button>

                        <button className="hover:bg-gray-300 border-2 px-4 py-1 rounded-lg"
                                onClick={() => setShow(false)}>
                            Cancel
                        </button>

                    </div>
                </div>
            </div>
        </div>

    )
}


export function ModalAddUser({setShow, apiGetUser}) {


    const [loadingCreate, setLoadingCreate] = useState(false);
    const [loading, setLoading] = useState(false);


    const [showDropDown, setShowDropDown] = useState(false);


    const [userName, setUserName] = useState("");
    const [email, setEmail] = useState("");
    const [address, setAddress] = useState("");
    const [country, setCountry] = useState({
        id: "",
        name: ""
    });
    const [password, setPassword] = useState("");
    const [mobile, setMobile] = useState("")


    const [dataListCountry, setDataListCountry] = useState([]);

    function CreateUser() {

        setLoadingCreate(true)

        const data = {

            userName: userName,
            email: email,
            address: address,
            country: country.id,
            password: password,
            mobile: `+${mobile}`

        }

        apiRequests.post(`/api/user/v1/register-user`, data)

            .then((res) => {
                toast.success(res.data.en_message)
                setShow(false)
                apiGetUser()
            })
            .catch(() => {
            })
            .finally(() => setLoadingCreate(false));

    }

    useEffect(() => {

        setLoading(true)
        apiRequests.get("/api/country/get-all?limit=20&page=1")
            .then((res) => {
                setDataListCountry(res.data.data.docs)
            })
            .catch()
            .finally(() => {
                setLoading(false)
            });

    }, []);

    return (

        <div className="report-modal fixed inset-0 bg-black bg-opacity-60 md:overflow-y-auto transition-opacity">
            <div className="flex min-h-full items-end justify-center p-3 text-center">
                <div
                    className="modal relative text-black transform overflow-hidden rounded-lg bg-white p-8 w-[60%] md:w-[90%] m-auto flex flex-col gap-5">

                    <div
                        className="grid grid-cols-2 md:flex md:flex-col auto-cols-auto gap-6  text-gray-900  justify-center">

                        <div className="mt-4">
                            <label className="block mb-2 text-left font-medium">User Name *</label>
                            <input
                                required
                                placeholder="enter User Name"
                                className="w-full p-2 border rounded-lg"
                                value={userName}
                                onChange={e => setUserName(e.target.value)}
                            />
                        </div>

                        <div className="mt-4 relative">
                            <label className="block mb-2 text-left font-medium">Phone Number *</label>
                            <input
                                required
                                placeholder="enter Phone Number "
                                className={`w-full p-2 border rounded-lg ${mobile !== "" &&  "pl-6" }`}
                                value={mobile}
                                onChange={e => setMobile(e.target.value)}
                            />
                            {mobile !== "" &&
                                (
                                    <span className="absolute top-12 left-2">
                                        <FaPlus size={12} />
                                    </span>
                                )
                            }

                        </div>

                        <div className="inline-block relative">
                            <div className="mt-4">
                                <label className="block mb-2 text-left font-medium">Country *</label>
                                <input
                                    required
                                    onClick={() => setShowDropDown(!showDropDown)}
                                    placeholder="enter Phone Number "
                                    className="w-full p-2 border rounded-lg"
                                    value={country.name}
                                    readOnly
                                />
                            </div>
                            {showDropDown &&
                                (
                                    loading ?
                                        <Loading/>
                                        :
                                        <Dropdown data={dataListCountry} setOpen={setShowDropDown}
                                                  setValue={setCountry}/>
                                )
                            }
                        </div>

                        <div className="mt-4">
                            <label className="block mb-2 text-left font-medium">Email Address *</label>
                            <input
                                required
                                placeholder="enter Email Address "
                                className="w-full p-2 border rounded-lg"
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                            />
                        </div>


                        <div className="mt-4">
                            <label className="block mb-2 text-left font-medium">Address *</label>
                            <input
                                required
                                placeholder="enter Email Address "
                                className="w-full p-2 border rounded-lg"
                                value={address}
                                onChange={e => setAddress(e.target.value)}
                            />
                        </div>

                        <div className="mt-4">
                            <label className="block mb-2 text-left font-medium">Password *</label>
                            <input
                                required
                                placeholder="enter Password "
                                className="w-full p-2 border rounded-lg"
                                type="password"
                                value={password}
                                onChange={e => setPassword(e.target.value)}
                            />
                        </div>

                    </div>

                    <div className="flex justify-center items-center gap-5 mt-8">

                        <button
                            className={`px-6 py-1 border-2 border-firstColor-shade4 rounded-lg `}
                            onClick={CreateUser}
                        >
                            {loadingCreate ?
                                <Loading textColor={`white-0`}/>
                                :
                                "Create User"
                            }
                        </button>

                        <button className="hover:bg-gray-300 border-2 px-4 py-1 rounded-lg"
                                onClick={() => setShow(false)}>
                            Cancel
                        </button>

                    </div>
                </div>
            </div>
        </div>

    )
}